import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { locale as common, mergeResources } from '@campai/lib-common/i18n'
import { locale as web } from '@campai/lib-web/i18n'

import { locale } from './locale'

const resources = mergeResources(locale, [common, web])

const updateResources = (nextResources: typeof resources) => {
    Object.entries(nextResources).forEach(([language, resource]) => {
        i18n.addResourceBundle(language, 'translation', resource.translation, true, true)
    })
}

export const initI18n = async () =>
    i18n.use(initReactI18next).init({
        resources,
        lng: 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        nsSeparator: false,
    })

if (import.meta.hot) {
    import.meta.hot.accept('./locale', (module) => {
        if (module) {
            updateResources(mergeResources(module.locale, [common, web]))
        }
    })
}

declare module 'i18next' {
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
    interface CustomTypeOptions {
        enableSelector: 'optimize'
        defaultNS: 'en'
        resources: {
            en: typeof resources.en.translation
        }
    }
}
